<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1 style="margin-top:-40px;">Copyright Information ©</h1>
<p style="text-indent:0; margin-top:-30px;">Andrew Cahill-Lloyd 2022</p><br/>
<p style="text-indent:0">The right of Andrew Cahill-Lloyd to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p><br/>
<p style="text-indent:0">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p><br/>
<p style="text-indent:0">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p><br/>
<p style="text-indent:0">This is a work of fiction. Names, characters, businesses, places, events, locales, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.</p><br/>
<p style="text-indent:0">A CIP catalogue record for this title is available from the British Library.</p><br/>
<p style="text-indent:0">ISBN 9781398490338 (Paperback)</p>
<p style="text-indent:0">ISBN 9781398490345 (ePub e-book)</p><br/>
<p style="text-indent:0">www.austinmacauley.com</p><br/>
<p style="text-indent:0">First Published 2022</p>
<p style="text-indent:0">Austin Macauley Publishers Ltd<sup>®</sup><br/>1 Canada Square</p>
<p style="text-indent:0">Canary Wharf</p>
<p style="text-indent:0">London</p>
<p style="text-indent:0">E14 5AA</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?d07f1a5c